var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var cachedIpAddress = "";
// Compatible fetch timeout helper using AbortController
var fetchWithTimeout = function (input_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([input_1], args_1, true), void 0, function (input, init, timeoutMs) {
        var controller, timeoutId, response;
        if (init === void 0) { init = {}; }
        if (timeoutMs === void 0) { timeoutMs = 5000; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    controller = new AbortController();
                    timeoutId = setTimeout(function () { return controller.abort(); }, timeoutMs);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, fetch(input, __assign(__assign({}, init), { signal: controller.signal }))];
                case 2:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 3:
                    clearTimeout(timeoutId);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var fetchAndStoreIpAddress = function () { return __awaiter(void 0, void 0, void 0, function () {
    var backendResponse, data, backendError_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // Return cached IP if available (and not empty)
                if (cachedIpAddress !== "") {
                    return [2 /*return*/, cachedIpAddress];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4 /*yield*/, fetchWithTimeout("/api/ipaddress", {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        }
                    }, 5000)];
            case 2:
                backendResponse = _a.sent();
                if (!backendResponse.ok) return [3 /*break*/, 4];
                return [4 /*yield*/, backendResponse.json()];
            case 3:
                data = _a.sent();
                if (data.ipAddress) {
                    cachedIpAddress = data.ipAddress;
                    // Store in localStorage for leadService to access
                    try {
                        localStorage.setItem("ipAddress", cachedIpAddress);
                    }
                    catch (storageError) {
                        console.debug("Failed to store IP in localStorage:", storageError);
                    }
                    return [2 /*return*/, cachedIpAddress];
                }
                _a.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                backendError_1 = _a.sent();
                console.debug("Backend IP fetch failed; skipping fallback (server-only mode).", backendError_1);
                return [3 /*break*/, 6];
            case 6:
                // Return empty string on failure. leadService will still submit; backend can capture IP independently.
                cachedIpAddress = "";
                return [2 /*return*/, cachedIpAddress];
        }
    });
}); };
/**
 * Clears the cached IP address
 * Useful for testing or forcing a fresh fetch
 */
export var clearIpCache = function () {
    cachedIpAddress = "";
    try {
        localStorage.removeItem("ipAddress");
    }
    catch (error) {
        console.debug("Failed to clear IP from localStorage:", error);
    }
};
